module.exports = __webpack_public_path__ + "55c7d5b1ca38664a122abaea4872c1f7.svg";